export default {
  'nav.poti': 'Wege',
  'nav.izhodisca': 'Startpunkte',
  'nav.galerija': 'Galerie',
  'nav.vreme': 'Wetter',
  'nav.o_nas': 'Über uns',
  'nav.zacni_pot': 'Weg beginnen',
  'nav.odpri_meni': 'Menü öffnen',
  'nav.zapri_meni': 'Menü schließen',
  'nav.preskoci': 'Zum Inhalt springen',

  'hero.badge': 'Tourismusverein STEZA — Šmarna Gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'Einer der schönsten, abwechslungsreichsten und einladendsten Wege für Besucher aller Generationen.',
  'hero.cta_start': 'Weg beginnen',
  'hero.cta_explore': 'Wege erkunden',
  'hero.cta_activities': 'Aktivitäten',
  'hero.scroll': 'Runterscrollen',

  'intro.badge': 'Willkommen',
  'intro.title': 'Šmarna Gora, der beliebteste Hügel Ljubljanas',
  'intro.desc': 'Šmarna Gora, der beliebteste Hügel bei Ljubljana, bietet zahlreiche Wege für Wanderer, Läufer und Naturfreunde.',
  'intro.highlight': 'Der Peske-Weg gilt als einer der schönsten, abwechslungsreichsten und einladendsten Pfade für Besucher jeden Alters.',
  'intro.pot_label': 'Peske-Weg',
  'intro.route': 'Spodnje Pirniče → Šmarna Gora',

  'activities.badge': 'Aktivitäten',
  'activities.title': 'ŠMARNA GORA ENTDECKEN',
  'activities.hiking.title': 'Wandern auf der Šmarna Gora',
  'activities.hiking.desc': 'Entdecken Sie verschiedene Wege, von leichten Spaziergängen bis zu anspruchsvolleren Aufstiegen.',
  'activities.cycling.title': 'Radfahren rund um Šmarna Gora',
  'activities.cycling.desc': 'Erkunden Sie malerische Radwege in der Umgebung mit wunderschönen Ausblicken.',
  'activities.running.title': 'Trailrunning auf der Šmarna Gora',
  'activities.running.desc': 'Ein beliebtes Ziel für Trailrunner — abwechslungsreiches Gelände mit idealer Steigung.',
  'activities.running_around.title': 'Laufen um Šmarna Gora',
  'activities.running_around.desc': 'Flache und sanfte Laufrunden am Fuß des Berges, ideal für das Freizeittraining.',
  'activities.walks.title': 'Spaziergänge am Fuß der Šmarna Gora',
  'activities.walks.desc': 'Ruhige Spaziergänge durch Wiesen und Waldwege, ideal für Familien.',

  'access.badge': 'Startpunkt',
  'access.title': 'STARTPUNKT & ZUGANG',
  'access.desc': 'Der Weg beginnt am Parkplatz LIPA in Spodnje Pirniče. Der Zugang ist einfach — mit dem Auto oder Bus.',
  'access.start_label': 'Startpunkt des Weges',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Parkplatz LIPA',
  'access.parking': 'Parkplatz',
  'access.free': 'Kostenlos',
  'access.bus': 'Bus',
  'access.bus_line': 'Linie 25',
  'access.info1': 'Parken Sie Ihr Fahrzeug am Parkplatz LIPA oder kommen Sie mit dem Bus Nummer 25 direkt zum Ausgangspunkt vor dem Gasthaus mit wunderschöner Terrasse, wo Sie ein erfrischendes Getränk oder einen Snack vor Beginn der Wanderung genießen können.',
  'access.info2': 'Am Anfang führt Sie ein schmaler, mit Hackschnitzeln bestreuter Weg an einer Wiese vorbei zum Wald, wo der Aufstieg beginnt.',

  // ── PARKING ──
  'parking.hero_title': 'Parkplatz LIPA — Offizieller Ausgangspunkt',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno. Kostenloser Parkplatz direkt am Beginn des Pot na Peske.',
  'parking.highlight_badge': '⭐ Offizieller Ausgangspunkt',
  'parking.section_title': 'PARKEN & ZUGANG',
  'parking.intro': 'Der LIPA-Parkplatz ist der offizielle, kostenlose und bequemste Ausgangspunkt für Pot na Peske — unseren schönsten Weg auf den Šmarna gora.',
  'parking.address_label': 'Adresse',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno, Slowenien',
  'parking.gps_label': 'GPS Koordinaten',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Kapazität',
  'parking.capacity_value': 'Kostenlos, Platz für 20+ Fahrzeuge',
  'parking.type_label': 'Parkplatztyp',
  'parking.type_value': 'Offener Schotterparkplatz',
  'parking.hours_label': 'Geöffnet',
  'parking.hours_value': '24/7 — das ganze Jahr',
  'parking.bus_info_title': 'Öffentliche Verkehrsmittel',
  'parking.bus_info': 'LPP-Buslinie 25 fährt direkt zur Haltestelle vor dem Parkplatz. Die Fahrt vom Stadtzentrum Ljubljana dauert etwa 30 Minuten.',
  'parking.facilities_title': 'Ausstattung',
  'parking.facility_gostilna': 'Restaurant mit schöner Terrasse direkt am Parkplatz',
  'parking.facility_wc': 'WC im Restaurant verfügbar',
  'parking.facility_info': 'Informationstafel am Beginn des Pot na Peske',
  'parking.facility_sign': 'STEZA / Pot na Peske Wegweiser',
  'parking.tips_title': 'Parktipps',
  'parking.tip1': 'An Wochenenden und Feiertagen ist der Parkplatz schnell voll — kommen Sie früh (vor 8 Uhr).',
  'parking.tip2': 'Der Parkplatz ist geschottert — im Winter auf mögliche Eisflächen achten.',
  'parking.tip3': 'Lassen Sie keine Wertsachen im Auto. Parken auf eigene Gefahr.',
  'parking.tip4': 'Zusätzlicher Parkplatz bei Gostilna Ledinek in Tacen (5 Min. Fahrt), falls LIPA voll ist.',
  'parking.map_title': 'Standort auf der Karte',
  'parking.cta_title': 'Bereit für Pot na Peske?',
  'parking.cta_subtitle': 'Parken Sie bei LIPA und starten Sie auf dem schönsten Weg zum Šmarna gora.',
  'parking.cta_btn': 'Weg beginnen',
  'parking.cta_routes': 'Alle Wege',

  'story.badge': 'Peske-Weg',
  'story.title': 'VOM STARTPUNKT ZUM GIPFEL',
  'story.subtitle': 'Eine filmreife Reise durch jede Etappe des Weges',
  'story.etapa': 'Etappe',
  'story.blocks.0.title': 'Sanfter Beginn',
  'story.blocks.0.text': 'Zunächst steigen wir sanft auf einem bequemen, breiten Weg auf, der teilweise mit Felsen und Wurzeln bedeckt ist. Bald biegen wir auf einen immer schmaleren Pfad ab, der etwas steiler ansteigt.',
  'story.blocks.0.terrain': 'Breiter Weg, Felsen, Wurzeln',
  'story.blocks.1.title': 'Abwechslungsreichster Abschnitt',
  'story.blocks.1.text': 'Wir gehen über zunehmend sandigen Boden, über Felsen und Wurzeln, teilweise durch eine relativ tiefe Rinne. Dies ist der steilste, aber auch der abwechslungsreichste Teil des Weges.',
  'story.blocks.1.terrain': 'Sandboden, Felsen, Rinne',
  'story.blocks.2.title': 'Schotterstraße',
  'story.blocks.2.text': 'Sobald sich der Pfad verbreitert und abflacht, erreichen wir bald eine breite Schotterstraße, den Fahrweg zur Šmarna Gora von Zavrh.',
  'story.blocks.2.terrain': 'Schotter, breiter Weg',
  'story.blocks.3.title': 'Türkendenkmal',
  'story.blocks.3.text': 'Hier weist uns ein Wegweiser nach rechts, vorbei am Pest- oder Türkendenkmal, das an die Zeiten der osmanischen Einfälle erinnert.',
  'story.blocks.3.terrain': 'Wegweiser, historischer Punkt',
  'story.blocks.4.title': 'Gorjanc-Kapelle',
  'story.blocks.4.text': 'Die Straße steigt sanft durch den Wald, der sich allmählich öffnet. Links steht die Gorjanc-Kapelle, wo der Brauch des Ablegens kleiner Kreuze erhalten geblieben ist.',
  'story.blocks.4.terrain': 'Forststraße, Kapelle',
  'story.blocks.5.title': 'Spodnji Gorjanc — Kreuzung',
  'story.blocks.5.text': 'Wir erreichen Spodnji Gorjanc, eine wichtige Wegkreuzung. Hier kreuzen sich die Wege nach Grmada, der Wurzelweg (Richtung Tacen) und die Fortsetzung zur Šmarna Gora.',
  'story.blocks.5.terrain': 'Wegkreuzung, Grmada, Wurzelweg',
  'story.blocks.6.title': 'Alpenblick',
  'story.blocks.6.text': 'Wir gehen weiter durch Weidewiesen, wo sich Ausblicke auf die Steiner Alpen und die Julischen Alpen mit dem Triglav öffnen.',
  'story.blocks.6.terrain': 'Weidewiesen, Panoramablick',
  'story.blocks.7.title': 'Sedlo — Kreuzung mit Grmada',
  'story.blocks.7.text': 'Am Sedlo (Sattel) kreuzt der Weg die Route zur Grmada und vereint sich mit Wegen aus Tacen, Šmartno und Vikrče. Von hier aus wählen Sie den einfacheren Schotterweg oder einen schmaleren, felsigeren Pfad an der St.-Sobota-Kapelle vorbei.',
  'story.blocks.7.terrain': 'Sattel, Kreuzung Grmada–Šmarna Gora, zwei Optionen',
  'story.blocks.8.title': 'Gipfel — Wegewahl',
  'story.blocks.8.text': 'Wir empfehlen den Aufstieg über den anspruchsvolleren Weg und den Abstieg über den sanfteren. So erleben Sie beide Seiten der Šmarna Gora und genießen das volle Erlebnis.',
  'story.blocks.8.terrain': 'Zwei Wege, Aufstieg und Abstieg',

  'highlight.title': 'Einer der einladendsten Wege auf der Šmarna Gora',
  'highlight.text1': 'Dies ist auch einer der einladendsten Wege auf der Šmarna Gora — nie exponiert, ohne große Steigungen und auch nach Regen angenehm zu gehen, wenn viele andere Wege matschig sind.',
  'highlight.text2': 'Der erste Abschnitt ist sehr abwechslungsreich und daher bei Wanderern, Läufern und Familien äußerst beliebt.',

  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'AUSSICHT VOM GIPFEL',
  'viewpoint.desc': 'Nehmen Sie sich auf dem Gipfel der Šmarna Gora bei klarem Wetter Zeit, um die herrliche Aussicht auf Ljubljana, die Save, die umliegenden Hügel und die Alpen zu genießen. Der Gipfel mit seiner malerischen Kirche bietet eines der schönsten Panoramen in Zentralslowenien.',

  'gallery.badge': 'Galerie',
  'gallery.title': 'Šmarna Gora durch die Linse',
  'gallery.subtitle': 'Momente, die den Berggeist zum Leben erwecken — jedes Foto erzählt seine eigene Geschichte',
  'gallery.enlarge': 'Vergrößern',
  'gallery.close': 'Vorschau schließen',
  'gallery.prev': 'Vorheriges Bild',
  'gallery.next': 'Nächstes Bild',
  'gallery.open': 'Bild öffnen',

  'weather.badge': 'Live-Wetter',
  'weather.title': 'WETTER AUF DER ŠMARNA GORA',
  'weather.loading': 'Aktualisiere...',
  'weather.updated': 'Zuletzt aktualisiert',
  'weather.current': 'Aktuell',
  'weather.feels_like': 'Gefühlt',
  'weather.wind': 'Wind',
  'weather.humidity': 'Luftfeuchtigkeit',
  'weather.visibility': 'Sichtweite',
  'weather.cloud_cover': 'Bewölkung',
  'weather.uv_index': 'UV-Index',
  'weather.rain': 'Regen',
  'weather.hiking_score': 'Wanderbewertung',
  'weather.out_of': 'von 100 Punkten',
  'weather.trail_safety': 'Wegsicherheit',
  'weather.safety_optimal': 'Sichere Bedingungen',
  'weather.safety_caution': 'Vorsicht geboten',
  'weather.safety_warning': 'Erschwerte Bedingungen',
  'weather.safety_danger': 'Gefährliche Bedingungen',
  'weather.no_alerts': 'Keine besonderen Warnungen',
  'weather.best_time': 'Beste Wanderzeit',
  'weather.next_hours': 'Nächste Stunden',
  'weather.seven_day': '7-Tage-Vorhersage',
  'weather.disclaimer': 'Die Daten dienen nur zur Information. Überprüfen Sie vor der Wanderung stets die offizielle Wettervorhersage. Quelle: Open-Meteo API.',
  'weather.error_load': 'Wetterdaten konnten nicht geladen werden',
  'weather.error_stale': 'Zeige letzte gespeicherte Daten',
  'weather.smarna_elevation': 'Šmarna Gora, 669m',

  'safety.badge': 'Wichtig',
  'safety.title': 'SICHERHEIT AUF DEM WEG',
  'safety.slippery_title': 'Rutschiger Untergrund',
  'safety.slippery_desc': 'Nach Regen sind Wurzeln und Felsen extrem rutschig. Tragen Sie Wanderschuhe mit gutem Profil. Vermeiden Sie Abkürzungen über nasses Gelände.',
  'safety.winter_title': 'Winterbedingungen',
  'safety.winter_desc': 'Im Winter können die Wege vereist sein. Winterausrüstung ist unerlässlich: Steigeisen, Wanderstöcke. Überprüfen Sie das Wetter vor der Abreise.',
  'safety.sunset_title': 'Sonnenaufgang / -untergang',
  'safety.sunset_desc': 'Wenn Sie zum Sonnenauf- oder -untergang aufbrechen, nehmen Sie unbedingt eine Stirnlampe mit. Informieren Sie immer jemanden über Ihr Ziel.',
  'safety.emergency_title': 'Notfall',
  'safety.emergency_desc': 'Im Notfall wählen Sie 112. Die Bergrettungs-App ermöglicht eine schnelle Ortung. Speichern Sie die Nummer vor der Wanderung.',
  'safety.warning_title': 'WARNUNG',
  'safety.warning_text': 'Die Informationen auf dieser Seite dienen nur zur Information. Wanderungen erfolgen auf eigene Gefahr. Überprüfen Sie vor jeder Wanderung die Wetterbedingungen, sorgen Sie für angemessene Ausrüstung und schätzen Sie Ihre körperliche Fitness ein. STEZA übernimmt keine Haftung für mögliche Verletzungen oder Unfälle.',

  'facebook.badge': 'Community',
  'facebook.title': 'MACHEN SIE MIT',
  'facebook.desc': 'Folgen Sie STEZA.SI auf Facebook für die neuesten Nachrichten, Veranstaltungen und Fotos',
  'facebook.label': 'Facebook Community',

  'webcam.badge': 'Live',
  'webcam.title': 'ŠMARNA GORA WEBCAM',
  'webcam.desc': 'Live-Blick vom Gipfel der Šmarna Gora — demnächst verfügbar',
  'webcam.coming_soon': 'Webcam bald verfügbar',
  'webcam.preparing': 'Wir bereiten eine Live-Übertragung vom Gipfel der Šmarna Gora vor. Vielen Dank für Ihre Geduld.',
  'webcam.status': 'In Vorbereitung',

  'media.badge': 'Medien',
  'media.title': 'GALERIE & VIDEO',
  'media.desc': 'Filmreife Aufnahmen und Fotografien der Šmarna Gora — demnächst verfügbar',
  'media.drone': 'DROHNENVIDEO IN PRODUKTION',
  'media.drone_desc': 'Filmreife Aufnahme des Peske-Weges',
  'media.views': 'Ausblicke',
  'media.trail': 'Weg',
  'media.history': 'Geschichte',

  'footer.desc': 'Der Peske-Weg — Šmarna Gora. Tourismusverein STEZA. Ein Premium-Wandererlebnis mit professionellen Informationen zu Wegen, Wetter und Sicherheit.',
  'footer.newsletter_title': 'Wander-Updates erhalten',
  'footer.newsletter_success': 'Vielen Dank! Sie sind jetzt für STEZA-Nachrichten angemeldet.',
  'footer.newsletter_placeholder': 'Ihre E-Mail-Adresse',
  'footer.newsletter_btn': 'Anmelden',
  'footer.trails': 'Wege',
  'footer.platform': 'Plattform',
  'footer.legal': 'Rechtliches',
  'footer.pot_peske': 'Peske-Weg',
  'footer.pot_korenine': 'Wurzelweg',
  'footer.mazijeva': 'Mazi-Weg',
  'footer.romarska': 'Pilgerweg',
  'footer.plezalna': 'Klettersteig',
  'footer.izhodisca': 'Startpunkte',
  'footer.galerija': 'Galerie',
  'footer.vreme': 'Wetter',
  'footer.o_stezi': 'Über STEZA',
  'footer.kontakt': 'Kontakt',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.cookies': 'Cookies',
  'footer.disclaimer': 'Haftungsausschluss',
  'footer.safety_notice': 'Sicherheitshinweis',
  'footer.copyright': '© 2026 STEZA.SI — Tourismusverein STEZA, Šmarna Gora',
  'footer.disclaimer_text': 'Wichtiger Hinweis: Die Informationen auf dieser Seite dienen nur zur Information. Wanderungen und Outdoor-Aktivitäten erfolgen auf eigene Gefahr. Überprüfen Sie vor dem Besuch die Wetterbedingungen, geeignete Ausrüstung und den Wegezustand.',
  'footer.facebook_label': 'STEZA auf Facebook',
  'footer.instagram_label': 'STEZA auf Instagram',

  'about.hero_title': 'Über STEZA',
  'about.hero_subtitle': 'Eine Premium-Wanderplattform, geschaffen aus Liebe zur Šmarna Gora.',
  'about.story_badge': 'Unsere Geschichte',
  'about.story_title': 'Der schönste Weg auf die Šmarna Gora',
  'about.story_p1': 'STEZA entstand aus einer einfachen Idee: Eine Wanderung auf die Šmarna Gora kann mehr als nur Erholung sein — sie kann ein Erlebnis sein. Wir haben eine Plattform geschaffen, die professionelle Wanderinformationen mit herausragender Ästhetik und moderner Technologie verbindet.',
  'about.story_p2': 'Wir sind ein Team aus Wanderern, Fotografen und Designern, die glauben, dass jeder Berg seine eigene Premium-Präsentation verdient. Šmarna Gora ist nicht nur ein Hügel — sie ist ein Symbol Ljubljanas, ein Wallfahrtsort, ein Naturjuwel und eine Sportarena in einem.',
  'about.story_p3': 'STEZA ist kein Touristenportal. Es ist kein Blog. Es ist eine Premium-Film-Wanderplattform für alle, die Šmarna Gora anders entdecken möchten.',
  'about.elevation_label': 'Šmarna Gora',
  'about.elevation': '669 m ü. M.',
  'about.how_title': 'Wie STEZA entstand',
  'about.how_p1': 'Die Geschichte begann auf dem Gipfel der Šmarna Gora. Wir standen auf der Aussichtsplattform, blickten zu den Alpen und fragten uns: Warum hat ein so wunderschöner Hügel keine moderne, übersichtliche und schöne Online-Präsenz? Alles, was wir fanden, waren verstreute Forenbeiträge, veraltete Blogs und minderwertige Fotos. Da beschlossen wir — wir würden etwas anderes schaffen.',
  'about.how_p2': 'Die nächsten sechs Monate verbrachten wir im Gelände. Wir gingen jeden Weg — vom leichtesten bis zum anspruchsvollsten. Wir fotografierten Sonnenaufgänge, regnerische Wälder, verschneite Gipfel und goldene Sonnenuntergänge. Wir sprachen mit lokalen Führern, Gastwirten, erfahrenen Wanderern und Erstbesuchern. Wir wollten Šmarna Gora aus jedem Blickwinkel verstehen.',
  'about.how_p3': 'STEZA ist nicht nur eine Website. Es ist ein visuelles Tagebuch unserer Liebe zu diesem Berg. Jedes Foto ist professionell aufgenommen, jeder Weg persönlich gegangen, jede Information geprüft. Wir glauben, dass Šmarna Gora — als eines der meistbesuchten Wanderziele Sloweniens — eine Präsentation von Weltklasse verdient.',
  'about.how_p4': 'Design-Inspiration zogen wir aus Premium-Outdoor-Marken wie Patagonia, The North Face und National Geographic Travel. Wir wollten eine Plattform schaffen, die Abenteuer atmet und gleichzeitig minimalistisch, sauber und professionell bleibt.',
  'about.how_p5': 'Heute deckt STEZA vier Hauptwege zur Šmarna Gora ab, Live-Wetterdaten, GPS-Navigation, Sicherheitshinweise und eine reiche Galerie. Aber dies ist erst der Anfang. Unsere Vision ist es, die beste Wanderplattform Sloweniens zu werden — und Šmarna Gora ist unser erstes, liebstes Projekt.',
  'about.gora_badge': 'Den Berg kennenlernen',
  'about.gora_title': 'Šmarna Gora — das Herz unserer Geschichte',
  'about.gora_subtitle': '669 Meter, die Generationen verbinden',
  'about.gora_p1': 'Šmarna Gora (669 m) ist der beliebteste Ausflugsgipfel in Zentralslowenien. Er liegt nur 10 Kilometer nordwestlich von Ljubljana, bietet aber trotz der Stadtnähe echten Naturkontakt, reiche Geschichte und atemberaubende Ausblicke.',
  'about.gora_p2': 'Es handelt sich um einen Inselberg — einen Hügel, der geologisch zu keinem größeren Gebirge gehört, sondern sich eigenständig über dem Laibacher Becken erhebt. Er besteht aus Kalkstein und Dolomit, seine Südhänge sind bekannt für wärmeliebende Pflanzenarten.',
  'about.gora_p3': 'Im Laufe der Jahrhunderte war Šmarna Gora alles: eine prähistorische Siedlung, ein strategischer Punkt mit Burg Šumberk, ein Wallfahrtsort, ein beliebtes Ausflugsziel der Stadtbewohner und heute ein unverzichtbarer Teil der sportlichen und kulturellen Identität Ljubljanas.',
  'about.history_title': 'In Stein gemeißelte Geschichte',
  'about.history_bronze_date': '1500 v. Chr.',
  'about.history_bronze_title': 'Bronzezeit',
  'about.history_bronze_text': 'Archäologische Funde auf dem Gipfel zeugen von einer prähistorischen Siedlung. Keramik, Werkzeuge und Siedlungsreste deuten auf eine dauerhafte Besiedlung in der Bronzezeit hin.',
  'about.history_castle_date': '12.–13. Jh.',
  'about.history_castle_title': 'Burg Šumberk',
  'about.history_castle_text': 'Auf dem Gipfel stand einst die mittelalterliche Burg Šumberk (Schönberg). Heute sind nur noch bescheidene archäologische Spuren und Ritterlegenden übrig.',
  'about.history_church_date': '1711',
  'about.history_church_title': 'Muttergotteskirche',
  'about.history_church_text': 'Eine Barockkirche wurde an der Stelle einer älteren gotischen Kirche aus dem 14. Jahrhundert errichtet. Sie wurde zum zentralen Wallfahrtsort Zentralsloweniens.',
  'about.history_modern_date': '19. Jh.–heute',
  'about.history_modern_title': 'Alpines Wanderziel',
  'about.history_modern_text': 'Mit der Entwicklung des Alpinismus wurde er zum beliebtesten Wanderziel der Laibacher. Diesen Status hält er bis heute mit über 500.000 Besuchern jährlich.',
  'about.nature_title': 'Natur, die inspiriert',
  'about.nature_p1': 'Die Südhänge der Šmarna Gora sind ein botanisches Paradies. Das warme Mikroklima begünstigt Pflanzen, die sonst viel weiter südlich vorkommen: Die Schwarze Nieswurz blüht bereits im Februar, gefolgt von der Duftenden Schwertlilie, der Gewöhnlichen Kuhschelle und der Herbstzeitlosen.',
  'about.nature_p2': 'Die Wälder sind Mischwälder — Buche, Eiche und Fichte dominieren, auf dem Gipfel wächst eine prächtige Kastanie. Die Tierwelt umfasst Rehe, Füchse, Wildschweine, Dachse, Eichhörnchen und Siebenschläfer.',
  'about.nature_p3': 'Wir fördern verantwortungsvolles Wandern — keine Spuren hinterlassen, keine Pflanzen pflücken, keine Tiere stören und den Müll ins Tal mitnehmen.',
  'about.legends_title': 'Legenden, die weiterleben',
  'about.legend_bell_title': 'Die Wunschglocke',
  'about.legend_bell_text': 'Die berühmteste Legende der Šmarna Gora. Wenn du dreimal läutest — zuerst für Gesundheit, dann für Glück und schließlich für Liebe — und dir bei jedem Läuten etwas wünschst, wird dein Wunsch in Erfüllung gehen.',
  'about.legend_castle_title': 'Burg Šumberk und der Schatz',
  'about.legend_castle_text': 'Die Legende besagt, dass die Ritter der Burg Šumberk vor dem Aufbruch zu den Kreuzzügen einen goldenen Schatz an den Hängen der Šmarna Gora vergruben. Er wurde nie gefunden.',
  'about.legend_mary_title': 'Die Marienerscheinung',
  'about.legend_mary_text': 'Der Volksüberlieferung nach erschien die Jungfrau Maria auf dem Gipfel, wodurch der Berg seinen Namen erhielt. Diese Überlieferung führte zum Bau der Kirche und einer über 300 Jahre währenden Wallfahrtstradition.',
  'about.stats_title': 'STEZA in Zahlen',
  'about.values_title': 'Unsere Werte',
  'about.values.professionalism': 'Professionalität',
  'about.values.professionalism_text': 'Alle Informationen werden sorgfältig geprüft und regelmäßig aktualisiert. Wir arbeiten mit lokalen Führern und der Bergrettung zusammen.',
  'about.values.aesthetics': 'Ästhetik',
  'about.values.aesthetics_text': 'Wir glauben, dass schöne visuelle Elemente der Schlüssel zur Inspiration sind. Jedes Foto auf der Seite ist professionell aufgenommen und kuratiert.',
  'about.values.safety': 'Sicherheit',
  'about.values.safety_text': 'Sicherheit steht an erster Stelle. Jeder Weg enthält detaillierte Warnungen, empfohlene Ausrüstung und Sicherheitshinweise.',
  'about.values.passion': 'Leidenschaft',
  'about.values.passion_text': 'STEZA ist ein Leidenschaftsprojekt. Jedes Teammitglied ist Wanderer und kennt jeden Weg auf der Šmarna Gora persönlich.',
  'about.values.sustainability': 'Nachhaltigkeit',
  'about.values.sustainability_text': 'Wir fördern verantwortungsvolles Wandern. Keine Spuren hinterlassen, Natur und Wildtiere respektieren, Müll mitnehmen.',
  'about.values.community': 'Gemeinschaft',
  'about.values.community_text': 'Wir bauen eine Gemeinschaft von Wanderern auf, die Erfahrungen teilen und sich gegenseitig helfen, Šmarna Gora zu entdecken.',
  'about.cta_title': 'Werden Sie Teil von STEZA',
  'about.cta_subtitle': 'Jeder Weg hat eine Geschichte. Entdecken Sie sie mit uns.',
  'about.cta_explore': 'Wege erkunden',
  'about.cta_contact': 'Kontaktieren Sie uns',

  'contact.hero_title': 'Kontakt',
  'contact.hero_subtitle': 'Haben Sie eine Frage, einen Vorschlag oder möchten Sie zusammenarbeiten? Schreiben oder rufen Sie uns an.',
  'contact.write_us': 'Schreiben Sie uns',
  'contact.email_label': 'E-Mail',
  'contact.phone_label': 'Telefon',
  'contact.location_label': 'Standort',
  'contact.location_value': 'Šmarna Gora, 1211 Ljubljana-Šmartno, Slowenien',
  'contact.follow_us': 'Folgen Sie uns',
  'contact.success_title': 'Vielen Dank für Ihre Nachricht!',
  'contact.success_text': 'Wir werden uns so schnell wie möglich bei Ihnen melden.',
  'contact.name_label': 'Name',
  'contact.name_placeholder': 'Ihr Name',
  'contact.email_placeholder': 'ihre@email.de',
  'contact.message_label': 'Nachricht',
  'contact.message_placeholder': 'Ihre Nachricht (max. 500 Zeichen)',
  'contact.submit': 'Nachricht senden',
  'contact.error_fields': 'Bitte füllen Sie alle Felder aus.',
  'contact.error_length': 'Nachricht zu lang. Maximal 500 Zeichen.',
  'contact.error_general': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',

  'routes.hero_title': 'Wege',
  'routes.hero_subtitle': 'Fünf einzigartige Wege zum Gipfel der Šmarna Gora. Vom leichten Peske-Weg bis zu anspruchsvollen Kletterrouten — wählen Sie Ihre STEZA.',
  'routes.explore': 'Weg erkunden',
  'routes.compare_title': 'Wegevergleich',
  'routes.table_pot': 'Weg',
  'routes.table_tezavnost': 'Schwierigkeit',
  'routes.table_trajanje': 'Dauer',
  'routes.table_visinska': 'Höhenmeter',
  'routes.table_dolzina': 'Länge',
  'routes.table_tip': 'Typ',
  'routes.cta_title': 'Bereit für Ihre STEZA?',
  'routes.cta_subtitle': 'Wählen Sie den Weg, der am besten zu Ihnen passt, und entdecken Sie Šmarna Gora auf eine unvergessliche Weise.',
  'routes.cta_find': 'Startpunkt finden',
  'routes.cta_weather': 'Wetter prüfen',
  'routes.difficulty_easy': 'Leicht',
  'routes.difficulty_moderate': 'Mittel',
  'routes.difficulty_hard': 'Schwer',

  'gallery_page.badge': 'Fotografische Sammlung',
  'gallery_page.title': 'Galerie',
  'gallery_page.subtitle': 'Eine Sammlung von Fotografien der Šmarna Gora — Wege, Ausblicke und Momente, die wir teilen.',
  'gallery_page.section_trail_title': 'Der Weg zum Gipfel',
  'gallery_page.section_trail_subtitle': 'Wanderwege durch Wald und Natur während des Aufstiegs',
  'gallery_page.section_summit_title': 'Der Gipfel',
  'gallery_page.section_summit_subtitle': 'Ausblicke, Panoramen und Momente auf dem Gipfel der Šmarna Gora',
  'gallery_page.section_parking_title': 'Parkplatz',
  'gallery_page.section_parking_subtitle': 'Zugang zum Ausgangspunkt und Parken zu allen Jahreszeiten',
  'gallery_page.empty_title': 'Die Sektion {title} ist bereit. Fügen Sie Bilder hinzu und sie erscheinen hier.',
  'gallery_page.empty_subtitle': 'Sektion ist bereit.',
  'gallery_page.close': 'Galerie schließen',
  'gallery_page.prev': 'Vorheriges Bild',
  'gallery_page.next': 'Nächstes Bild',
  'gallery_page.open': 'Bild ansehen',
  'gallery_page.cta_title': 'Machen Sie Ihr eigenes Foto',
  'gallery_page.cta_subtitle': 'Die schönsten Fotos entstehen auf dem Gipfel. Teilen Sie Ihre besten Aufnahmen mit dem Hashtag #STEZA.',
  'gallery_page.cta_btn': 'Finden Sie Ihren Weg',

  'legal.not_found': 'Seite nicht gefunden',
  'legal.back_home': '← Zurück zur Startseite',
  'legal.updated': 'Letzte Aktualisierung',
  'legal.copyright': '© 2026 STEZA.SI — Alle Rechte vorbehalten. Kontakt: info@steza.si',

  'notfound.title': 'Diese Seite wurde noch nicht erstellt',
  'notfound.subtitle': 'Erzählen Sie mir mehr über diese Seite, damit ich sie erstellen kann',
  'notfound.back_home': 'Zurück zur Startseite',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'Peske-Weg — Šmarna Gora | STEZA — Premium-Wanderplattform',
  'seo.home_desc': 'Der Peske-Weg ist einer der schönsten Wege zur Šmarna Gora. Ein Premium-Wandererlebnis mit professionellen Informationen zu Wegen, Wetter, Sicherheit und Aussichtspunkten. Tourismusverein STEZA.',
  'seo.home_keywords': 'Peske-Weg, Šmarna Gora, Wandern Šmarna Gora, Wandern Slowenien, Šmarna Gora Wege, Wandern Ljubljana, Bergsteigen Slowenien',
  'seo.og_title': 'Peske-Weg — Šmarna Gora | STEZA',
  'seo.og_desc': 'Premium-Wanderplattform für Šmarna Gora. Entdecken Sie den Peske-Weg — einen der schönsten und einladendsten Wege zur Šmarna Gora.',
  'seo.schema_desc': 'Der Peske-Weg ist einer der schönsten Wege zur Šmarna Gora. Tourismusverein STEZA — eine Premium-Wanderplattform für Šmarna Gora.',
};